import { render, staticRenderFns } from "./StudyCardManage.vue?vue&type=template&id=14ef4e3a&"
import script from "./StudyCardManage.vue?vue&type=script&lang=js&"
export * from "./StudyCardManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports